import { render, staticRenderFns } from "./ShopDataList.vue?vue&type=template&id=19ccaec4&scoped=true"
import script from "./ShopDataList.vue?vue&type=script&lang=js"
export * from "./ShopDataList.vue?vue&type=script&lang=js"
import style0 from "./ShopDataList.vue?vue&type=style&index=0&id=19ccaec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ccaec4",
  null
  
)

export default component.exports